// extracted by mini-css-extract-plugin
export default {"root":"post-button_root__TjyFQ"};